import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { getStatusIcon, useAlertContext, useAlertStyles } from "./chunk-FZCW3KO4.mjs";

// src/alert-icon.tsx
import { chakra } from "@chakra-ui/system";
import { cx } from "@chakra-ui/shared-utils";
import { jsx } from "react/jsx-runtime";
function AlertIcon(props) {
  var _useAlertContext = useAlertContext(),
    status = _useAlertContext.status;
  var BaseIcon = getStatusIcon(status);
  var styles = useAlertStyles();
  var css = status === "loading" ? styles.spinner : styles.icon;
  return /* @__PURE__ */jsx(chakra.span, _objectSpread(_objectSpread({
    display: "inherit"
  }, props), {}, {
    className: cx("chakra-alert__icon", props.className),
    __css: css,
    children: props.children || /* @__PURE__ */jsx(BaseIcon, {
      h: "100%",
      w: "100%"
    })
  }));
}
AlertIcon.displayName = "AlertIcon";
export { AlertIcon };